<fieldset class="form-group display-inline-block full-width" [formGroup]="form">
  <ng-select [items]="flows" multiple="true" bindLabel="name" bindValue="id" placeholder="Selecciona un flujo"
    clearAllText="Clear" formControlName="idFlow" (change)="flowSelected.emit(form.get('idFlow').value)"></ng-select>
</fieldset>